import { create } from 'zustand';

export const useFileSelected = create((set) => ({
  fileSelected: null,
  setFileSelected: (file: string) => set(() => ({ fileSelected: file }))
}));

export const useRequestConnectorsSent = create((set) => ({
  sentRequest: false,
  setSentRequest: (sent: boolean) => set(() => ({ sentRequest: sent }))
}));

export const useAccountHasPlanPaid = create((set) => ({
  accountPaid: null,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useAccountHasTrialPlanPaid = create((set) => ({
  trialAccountPaid: null,
  setTrialAccountPaid: (paid: boolean) => set(() => ({ trialAccountPaid: paid }))
}));

export const useAccountHasStarterPlan = create((set) => ({
  accountPaid: null,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useAccountHasFreePlan = create((set) => ({
  freeAccount: false,
  setFreeAccount: (freeAccount: boolean) => set(() => ({ freeAccount: freeAccount }))
}));

export const useReloadAccountHasPlanPaid = create((set) => ({
  accountPaid: false,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useFileName = create((set) => ({
  fileName: null,
  setFileName: (file: string) => set(() => ({ fileName: file }))
}));

export const useProjectsNumber = create((set) => ({
  projectsUploaded: 0,
  setProjectsUploaded: (projects: number) => set(() => ({ projectsUploaded: projects }))
}));

export const useSheetName = create((set) => ({
  name: '',
  setName: (name: string) => set(() => ({ name: name }))
}));

export const useSheetsName = create((set) => ({
  names: [],
  setNames: (names: string[]) => set(() => ({ names: names }))
}));

export const useShowsSheetsScreen = create((set) => ({
  show: false,
  setShow: (show: boolean) => set(() => ({ show: show }))
}));

export const useSheetsScreenDone = create((set) => ({
  done: false,
  setDone: (done: boolean) => set(() => ({ done: done }))
}));

export const useFileUploadIsCSV = create((set) => ({
  isCSV: false,
  setIsCSV: (isCSV: boolean) => set(() => ({ isCSV: isCSV }))
}));

export const useStepsNumberLoader = create((set) => ({
  step: 0,
  setStep: (step: number) => set(() => ({ step: step }))
}));

export const useIsReadyFile = create((set) => ({
  isReady: false,
  setIsReady: (isReady: boolean) => set(() => ({ isReady: isReady }))
}));

export const useIsShortenedFile = create((set) => ({
  shortened: false,
  setShortened: (done: boolean) => set(() => ({ shortened: done }))
}));

export const useIsAppDown = create((set) => ({
  isAppDown: false,
  setIsAppDown: (isAppDown: boolean) => set(() => ({ isAppDown: isAppDown }))
}));

export const useIsFirebaseDown = create((set) => ({
  isAppDown: false,
  setIsAppDown: (isAppDown: boolean) => set(() => ({ isAppDown: isAppDown }))
}));

export const useForceCloseUploading = create((set) => ({
  force: false,
  setForce: (force: boolean) => set(() => ({ force: force }))
}));

export const useUpgradePlanToggle = create((set) => ({
  checked: false,
  setChecked: (checked: any) => set(() => ({ checked: checked }))
}));

export const useShowErrorModalComingSoon = create((set) => ({
  showModalError: false,
  setShowModalError: (showModalError: boolean) => set(() => ({ showModalError: showModalError }))
}));

export const useExpandFileUpload = create((set) => ({
  expand: false,
  setExpand: (expand: boolean) => set(() => ({ expand: expand }))
}));

export const useShowStepsUploading = create((set) => ({
  showSteps: false,
  setShowSteps: (showSteps: boolean) => set(() => ({ showSteps: showSteps }))
}));
